'use client'

import { ArrowLeft } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { Button } from '../ui/button'

export default function ServerError({ error }) {
  const router = useRouter()
  const errorMessage = (() => {
    switch (error.cause?.code) {
      case 400:
        return 'Could not find resource.'
      case 401:
        return 'You are not authorized to access this resource.'
      case 403:
      case 404:
        return error.message || 'Please contact us if this persists.'
      case 500:
        return 'Something went wrong on our end - Please contact us if this persists.'
      default:
        return 'Please contact us if this persists.'
    }
  })()

  async function handleGoBack() {
    router.back()
  }

  return (
    <div className="col-span-full flex w-full flex-col items-center rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 py-10 align-middle font-inter">
      <h5 className="mx-auto text-h-5">We've encountered an error.</h5>
      <p className="mx-auto mt-4 px-3 text-p-2">{errorMessage}</p>
      <Button className="mt-6 flex items-center gap-2" onClick={handleGoBack}>
        <ArrowLeft className="size-4" />
        <p>Go back</p>
      </Button>
    </div>
  )
}
